import React from 'react';
import {ModelFormField} from "../../../../components/ModelFormHOC";
import {FazendaObject} from "../../../../models/Fazenda";

interface FormQuestionarioCorteProps {
  fazenda: FazendaObject;
}

const FormQuestionarioLeite: React.FC<FormQuestionarioCorteProps> = ({fazenda}) => {
  return (
    <>
      <div className="text-xl font-hairline mt-6">
        Fazendas de leite
      </div>

      <ModelFormField field="intervalo_entre_partos"/>
      <ModelFormField field="producao_litros_dia"/>

      <div className="text-xl font-hairline mt-6">
        Rebanho de Leite
      </div>
      <ModelFormField field="vacas_ordenhadas"/>
      <ModelFormField field="leite_vacas_secas"/>
      <ModelFormField field="leite_novilhas"/>
      <ModelFormField field="leite_bezerras"/>
    </>
  );
}

export default FormQuestionarioLeite;
